import { useEffect, useState, type ComponentProps } from 'react';

import defu from 'defu';
import _ from 'lodash';

import { fetchImage } from '@Blocks/_lib/getImageUrl';

import {
	type TxtImgRepeaterType,
	type TxtImgType,
	type TxtImgVariations,
} from '@/src/Types/Blocks/TxtImg';
import { type ContainerTypeEnums, type PositionsAlignement } from '@/src/Types/Shared/Common';
import type { Options } from '@/src/Types/Shared/Options';
import { getBtnStyle, TxtImgStyle } from '@Views/Shared/GlobalStyles/GlobalStyles';

import Block from './Block';

type TxtImgRegister = {
	block: TxtImgType;
	variant: TxtImgVariations;
	containerType: ContainerTypeEnums;
	headingAlign: PositionsAlignement;
	options: Options;
};

export default function TxtImg(props: TxtImgRegister) {
	const {
		block,
		variant = 'classic',
		containerType = 'wide',
		headingAlign = 'center',
		options,
	} = props;

	const [images, setImages] = useState<TxtImgRepeaterType[]>(block.images);
	const { composition } = block;

	useEffect(() => {
		let ignore = false;

		const fetchImageUrls = async () => {
			try {
				const updatedImages = await Promise.all(
					block.images.map(async (image) => {
						const response = await fetchImage(image.image ? image.image : '', 'large');
						return { ...image, imgUrl: response.url, imageAlt: response.alt };
					})
				);
				if (!ignore) {
					setImages(updatedImages);
				}
			} catch (e) {
				// skip error
			}
		};

		if (block.images && block.images.length > 0) {
			fetchImageUrls();
		}

		return () => {
			ignore = true;
		};
	}, [block.images]);

	/* const sectionBgColor = options.blocks.txtImg.default.bgColor;
	const elementBgColor = options.blocks.txtImg.default.wrapperBgColor; */

	let txtProps: ComponentProps<typeof Block> = {
		id: block.id ? block.id : '',
		title: block.title,
		description: block.description,
		titleFormat: block.titleFormat,
		images: images,
		containerType: containerType,
		variant: variant,
		headingAlign: headingAlign,
		contentFontFormats: block.contentFontFormats,
		ctasStyle: getBtnStyle(options, options.blocks.txtImg.default.ctasStyle),
		style: {},
		placement: block.placement,
		sectionDecoration: options.layout.sectionDecoration,
	};

	if (composition && composition != 'none') {
		const compoOptions = _.find(options.blocks.txtImg.compositions, { id: composition });
		if (compoOptions) {
			txtProps = defu(compoOptions as ComponentProps<typeof Block>, txtProps);
			txtProps.ctasStyle = getBtnStyle(options, compoOptions.ctasStyle);
			txtProps.style = TxtImgStyle(options, compoOptions);
		}
	}

	return <Block {...txtProps} />;
}
